# File uploader used throughout the entire frontend app. It allows a user to select several documents and uploads them
# asynchronously to the server. Listing allows files to be deleted. Orientation is automatically detected based on
# JPEG tags

# Retrieve image orientation through an ArrayBuffer
getOrientation = (file, callback) ->
  reader = new FileReader
  reader.onload = (e) ->
    try
      view = new DataView(e.target.result)
      if view.getUint16(0, false) != 0xFFD8
        return callback(-2)
      length = view.byteLength
      offset = 2
      while offset < length
        marker = view.getUint16(offset, false)
        offset += 2
        if marker == 0xFFE1
          little = view.getUint16(offset += 8, false) == 0x4949
          offset += view.getUint32(offset + 4, little)
          tags = view.getUint16(offset, little)
          offset += 2
          i = 0
          while i < tags
            if view.getUint16(offset + i * 12, little) == 0x0112
              return callback(view.getUint16(offset + i * 12 + 8, little))
            i++
        else if (marker & 0xFF00) != 0xFF00
          break
        else
          offset += view.getUint16(offset, false)
    callback -1
  reader.readAsArrayBuffer file.slice(0, 64 * 1024)

setupFileUploader = ->
  $('[data-behaviour="file-uploader"]').each (index, el) ->
    $el = $ el
    ACCEPTED_MIME_TYPES = $el.attr('accept').split ','
    MAX_FILE_SIZE = 20 * 1024 * 1024
    BASE_URL = $el.data 'action'
    fileKey = 0
    files = {}
    $root = $el.closest('.file-uploader')
    $drop = $root.find $el.data('view-drop')
    $ul = $root.find $el.data('list')
    $listItemTemplate = $root.find($el.data('list-template')).children()

    isAcceptedMimeType = (f) ->
      ACCEPTED_MIME_TYPES.some (type) ->
        type == f.type

    # DOM manipulation
    addListItem = (f, fileKey) ->
      $li = $listItemTemplate.clone()
      $li.find("[class$='filename']").append f.name
      $li.attr 'data-key', fileKey
      $icon = $li.find "[class$='icon']"
      $ul.append $li
      if f.type.match 'image*'
        blobUrl = window.URL.createObjectURL(f)
        $li.find("[class$='icon']").addClass('type-image').css 'background-image', "url(#{blobUrl})"
        getOrientation f, (orientation) ->
          if orientation != -1 || orientation != -2 # -1 not defined, -2 not jpeg/photo
            switch orientation
              when 6 then angle = 90
              when 3 then angle = 180
              when 8 then angle = -90
            value = "rotate(#{angle}deg)"
            props =
              '-webkit-transform': value
              '-moz-transform':    value
              '-o-transform':      value
              '-ms-transform':     value
              'transform':         value
            $icon.css(props).css 'display', 'block'
      else
        $icon.css 'display', 'block'
      $li

    # data manipulation
    buildFiles = ->
      $ul.find('li').each (index, elem) ->
        $li = $ elem
        files[fileKey] =
          id: $li.data 'id'
          name: $li.data 'name'
        $li.attr 'data-key', fileKey
        fileKey++

    addFile = (f) ->
      $li = addListItem f, fileKey
      files[fileKey] =
        id: null
        name: f.name
        file: f
        req: createRequest f, $li, fileKey
      fileKey++

    processFileInput = (ev) ->
      if (filesObj = ev.target.files || ev.originalEvent.dataTransfer.files).length
        for f in filesObj
          if !isAcceptedMimeType(f)
            alert($CAM.t('file_uploader', 'upload_wrong_type').replace('{file}', f.name))
          else if f.size > MAX_FILE_SIZE
            alert($CAM.t('file_uploader', 'upload_too_big').replace('{file}', f.name))
          else
            addFile(f)
      $el.val '' # reset

    # Rails rejects a non-GET request without this. rails-ujs adds it through a
    # `$.ajaxPrefilter`, but only on the jQuery instance that was global while it
    # loaded -- cam_backend's -- and the build gives this bundle one of its own
    # (see vite.config.mts), whose prefilters are empty. So read the same meta
    # tag rails-ujs reads and set the header here, which holds either way.
    csrfHeaders = ->
      token = document.querySelector('meta[name="csrf-token"]')?.content
      if token then { 'X-CSRF-Token': token } else {}

    generateErrorMessage = (jqXhr) ->
      return $CAM.t('file_uploader', 'upload_blocked') if jqXhr.status == 403
      jqXhr.responseJSON?.error || $CAM.t('file_uploader', 'upload_fail')

    createRequest = (f, li, fileKey) ->
      $barInner = $(li).find "[class$='bar-inner']"
      $progress = $(li).find "[class$='entry__progress']"
      $filename = $(li).find "[class$='entry__filename']"
      data = new FormData()
      data.append 'file', f
      if window.location.pathname.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/.+/i)
        data.append 'step', window.location.pathname.split('/').pop()
      if $el.data('field')
        data.append 'field', $el.data('field')

      request = $.ajax(
        xhr: ->
          xhr = $.ajaxSettings.xhr()
          xhr.upload.onprogress = (ev) ->
            l = ev.loaded
            t = ev.total
            percent = Math.floor(l / t * 100) + '%'
            $progress.text "#{$CAM.formatFileSize(l)} #{$CAM.t('file_uploader', 'of')} #{$CAM.formatFileSize(t)}"
            $barInner.css 'width', percent
          xhr
        beforeSend: ->
          classes = 'upload-success upload-error'
          $progress.text ''
          $barInner.parent().css 'display', 'block'
          $barInner.css 'width', 0
          $barInner.removeClass classes
          $progress.removeClass classes
        url: BASE_URL
        data: data
        headers: csrfHeaders()
        cache: false
        contentType: false
        processData: false
        type: 'POST'
      ).done( (data) ->
        $barInner.addClass('upload-success')
        $progress.addClass('upload-success').delay(1000).fadeOut 300
        tId = setTimeout ->
          $progress.text($CAM.t('file_uploader', 'upload_success')).fadeIn 300
          $barInner.parent().delay(1500).fadeOut()
          clearTimeout tId
        , 1700
        files[fileKey].id = data.id
        $filename.text data.filename
      ).fail (jqXhr) ->
        $barInner.addClass 'upload-error'
        $barInner.parent().delay(1500).fadeOut()
        $progress.addClass('upload-error').text generateErrorMessage(jqXhr)

    removeFile = (ev, fileKey) ->
      if files[fileKey].hasOwnProperty 'req'
        req = files[fileKey].req
        if req.readyState < 4 # If the request is not done, abort it
          req.abort()
          return
      if (id = files[fileKey].id)?
        $.ajax(
          url: BASE_URL + "/#{id}"
          method: 'DELETE'
          headers: csrfHeaders()
        ).done( (data) ->
        ).fail( (req, textStatus, errorThrown) ->
          console.log textStatus
          console.log errorThrown
        )

    # runtime
    buildFiles()
    $el.on 'change', processFileInput
    $el.on 'removeFile', removeFile
    $($el[0].form).on 'submit', (e) -> $el.remove()

    # Listen for drag events on the window
    $(window).on 'dragover drop dragend dragleave', (ev) ->
      ev.preventDefault() unless ev.target.type == 'file'
      $drop.toggleClass 'hover', ev.type == 'dragover'

$ ->
  # Behaviour for removal of files
  $(document).on 'click', '[data-behaviour="remove-file"]', (ev) ->
    ev.preventDefault()
    $el = $ @
    $li = $el.parent()
    $el.closest('.file-uploader').find($el.data('view')).trigger 'removeFile', $li.data('key')
    $li.remove()

  setupFileUploader()
